import { useB3Lang } from '@b3/lang';

import { B3Tag } from '@/components';
import { getOrderStatus } from '@/pages/order/shared/getOrderStatus';

interface OrderStatusProps {
  code: string | number;
  text?: string;
}

export default function OrderStatus({ code, text }: OrderStatusProps) {
  const b3Lang = useB3Lang();
  const status = getOrderStatus(code);

  if (!status) return null;

  // Use the translation key directly from the unified object.
  const translatedStatus = b3Lang(status.translationKey) || text || status.label;

  return (
    <B3Tag color={status.color} textColor={status.textColor}>
      {translatedStatus}
    </B3Tag>
  );
}
